import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
  selector: 'analysis-profile-card',
  template: `<div class="card-container" [class.-bordered]="profileManagement">
    <img
      class="card-image"
      [src]="profileImage || pathProfileIcon"
      alt="Foto de perfil de {{ profileName }}"
    />
    <span
      class="card-name"
      ngxClipboard
      [cbContent]="profileId"
      title="Clique para copiar"
      >{{ profileName }}</span
    >
  </div>`,
  styleUrls: ['./profile-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileCardComponent implements OnInit {
  pathProfileIcon = './assets/images/profile_placeholder.png';
  @Input()
  profileId: string;

  @Input()
  profileName: string;

  @Input()
  profileImage: string;

  @Input()
  profileManagement: boolean;

  constructor() {}

  ngOnInit(): void {}
}
